import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgNominationBedAllocation({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M5.65 9C6.396 9 7 9.604 7 10.35v2.8a1.35 1.35 0 01-1.35 1.35h-3.8A1.35 1.35 0 01.5 13.15v-2.8C.5 9.604 1.104 9 1.85 9zm7.546-.003l.084.073 2 2a.75.75 0 01.073.976l-.073.084-2 2a.75.75 0 01-1.133-.976l.073-.084.719-.721-3.539.001a.75.75 0 01-.102-1.493l.102-.007 3.538-.001-.718-.719a.75.75 0 01-.073-.976l.073-.084a.75.75 0 01.976-.073zM5.5 10.5H2V13h3.5v-2.5zm7.696-8.703l.084.073 2 2a.75.75 0 01.073.976l-.073.084-2 2a.75.75 0 01-1.133-.976l.073-.084.718-.72H9.4a.75.75 0 01-.102-1.493L9.4 3.65h3.539l-.72-.72a.75.75 0 01-.072-.976l.073-.084a.75.75 0 01.976-.073zM5.65 1.5C6.396 1.5 7 2.104 7 2.85v2.8A1.35 1.35 0 015.65 7h-3.8A1.35 1.35 0 01.5 5.65v-2.8c0-.746.604-1.35 1.35-1.35zM5.5 3H2v2.5h3.5V3z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgNominationBedAllocation.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgNominationBedAllocation.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgNominationBedAllocation svgRef={ref} {...props} />
));
export default ForwardRef;
